module.exports = __webpack_public_path__ + "img/documentsDodIcon.08401702.svg";